(function () {
  if (window.__kaapiPage) return;
  window.__kaapiPage = true;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const qs = (sel) => document.querySelector(sel.charAt(0) === "#" ? sel : `.kaapi-page ${sel}`);
  const qsa = (sel) => [...document.querySelectorAll(sel.charAt(0) === "#" ? sel : `.kaapi-page ${sel}`)];

  let products = {};
  try {
    const node = document.getElementById("kaapi-products");
    (node ? JSON.parse(node.textContent) : []).forEach((item) => {
      if (item && item.key) products[item.key] = item;
    });
  } catch (error) {
    products = {};
  }

  const keys = Object.keys(products);
  let activeProduct = keys[0] || "filter";
  let activeGender = "men";
  let selectedSize = null;
  let toastTimer;
  let ticking = false;
  let galleryIndex = 0;
  let galleryImages = [];
  let swipeBound = false;
  let addingToCart = false;

  const productRoot = qs(".product");
  let productImage = qs("#product-image") || qs(".product__image-wrap img");
  const productName = qs("#product-name");
  const productMood = qs("#product-mood");
  const productPrice = qs("#product-price");
  const productPriceAmount = qs("#product-price-amount");
  const productDescription = qs("#product-description");
  const productUpper = qs("#product-upper");
  const productCount = qs(".product__image-count");
  const productCaption = qs("#product-caption");
  const roastSelected = qs("#roast-selected");
  const buyButton = qs("[data-buy]");
  const dock = qs(".order-dock");
  const dockName = qs(".order-dock__name");
  const dockSize = qs(".order-dock__size");
  const dockBuy = qs("[data-dock-buy]");
  const toast = qs(".toast");
  const orderSection = qs(".order");
  const beanStory = qs(".bean-story");
  const storyBean = qs(".bean-story__rail img");
  const pourSection = qs(".pour");
  const pourMedia = qs(".pour__media");
  const pourSticky = qs(".pour__sticky");
  const lastCall = qs(".last-call");
  const pageProgress = qs(".page-progress span");
  const sizesWrap = qs(".sizes");
  const galleryWrap = qs("#product-gallery");

  function clamp(value, min = 0, max = 1) {
    return Math.min(max, Math.max(min, value));
  }

  function currentGender() {
    const item = products[activeProduct] || {};
    return (item.genders && item.genders[activeGender]) || (item.genders && item.genders.men) || null;
  }

  function sizeKey(value) {
    return String(value == null ? "" : value).replace(/^UK\s*/i, "").trim();
  }

  function selectedVariant() {
    const gender = currentGender();
    if (!gender || !selectedSize || !gender.variants) return null;
    return gender.variants.find((variant) => sizeKey(variant.size) === String(selectedSize)) || null;
  }

  function shopUrl() {
    const gender = currentGender();
    if (!gender) return "/collections/all";
    const match = selectedVariant();
    if (match && match.url) return match.url;
    return gender.url || "/collections/all";
  }

  function currentPrice() {
    const match = selectedVariant();
    if (match && match.price) return match.price;
    const gender = currentGender();
    return (gender && gender.price) || "";
  }

  function syncPrice() {
    if (!productPrice) return;
    const price = currentPrice();
    if (productPriceAmount) productPriceAmount.textContent = price;
    else productPrice.textContent = price;
    productPrice.hidden = !price;
  }

  function selectSize(button) {
    if (!button || !sizesWrap) return;
    sizesWrap.querySelectorAll("button").forEach((item) => {
      item.classList.remove("is-selected");
      item.setAttribute("aria-pressed", "false");
    });
    button.classList.add("is-selected");
    button.setAttribute("aria-pressed", "true");
    selectedSize = button.dataset.size;
  }

  function renderSizes() {
    if (!sizesWrap) return;
    const gender = currentGender();
    const variants = (gender && gender.variants) || [];
    sizesWrap.innerHTML = variants.map((variant) => {
      const size = sizeKey(variant.size);
      return `<button type="button" aria-pressed="false" data-size="${size}">UK ${size}</button>`;
    }).join("");
    sizesWrap.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", () => {
        selectSize(button);
        syncBuyState();
      });
    });
    const firstAvailable = variants.find((variant) => variant.available !== false) || variants[0];
    const firstButton = firstAvailable
      ? sizesWrap.querySelector(`button[data-size="${sizeKey(firstAvailable.size)}"]`)
      : sizesWrap.querySelector("button[data-size]");
    if (firstButton) selectSize(firstButton);
    else selectedSize = null;
  }

  function syncBuyState() {
    const item = products[activeProduct];
    if (!item || !buyButton) return;
    const label = selectedSize ? `ADD TO CART / UK ${selectedSize}` : "ADD TO CART";
    const labelNode = buyButton.querySelector("span");
    if (labelNode) labelNode.textContent = label;
    if (dockName) dockName.textContent = item.name;
    if (dockSize) dockSize.textContent = selectedSize ? `SIZE ${selectedSize}` : "SIZE —";
    if (dockBuy) dockBuy.textContent = selectedSize ? "SHOP THIS PAIR" : "CHOOSE A SIZE";
    syncPrice();
  }

  function setHeroImage(src, alt) {
    productImage = qs("#product-image") || qs(".product__image-wrap img");
    if (!productImage || !src) return;
    productImage.removeAttribute("srcset");
    productImage.removeAttribute("sizes");
    productImage.src = src;
    productImage.setAttribute("src", src);
    if (alt != null) productImage.alt = alt;
  }

  function currentMedia() {
    const item = products[activeProduct] || {};
    const gender = currentGender() || {};
    const gallery = (gender.gallery && gender.gallery.length ? gender.gallery : []) || [];
    const image = gender.image || gallery[0] || "";
    return { item, gender, gallery, image };
  }

  function padCount(value) {
    return String(value).padStart(2, "0");
  }

  function renderProduct(key) {
    const item = products[key];
    if (!item || !productRoot) return;
    productRoot.dataset.activeProduct = key;
    const media = currentMedia();
    setHeroImage(media.image, item.alt || "");
    if (productName) productName.textContent = item.name;
    if (productMood) productMood.textContent = item.mood || "";
    if (productDescription) productDescription.textContent = item.description || "";
    if (productUpper) productUpper.textContent = item.upper || "";
    if (productCaption) productCaption.textContent = item.name;
    syncRoastLabel(key);
    renderGallery(media);
    renderSizes();
  }

  function syncRoastLabel(key) {
    if (!roastSelected) return;
    const cardTitle = document.querySelector(`.kaapi-page [data-product-tab="${key}"] b`);
    if (cardTitle) roastSelected.textContent = cardTitle.textContent.trim();
  }

  function galleryList() {
    const media = currentMedia();
    const images = (media.gallery && media.gallery.length ? media.gallery : [media.image]).filter(Boolean);
    return images;
  }

  function showGalleryAt(index) {
    galleryImages = galleryImages.length ? galleryImages : galleryList();
    if (!galleryImages.length) return;
    galleryIndex = (index + galleryImages.length) % galleryImages.length;
    setHeroImage(galleryImages[galleryIndex]);
    if (productCount) productCount.textContent = `${padCount(galleryIndex + 1)} / ${padCount(galleryImages.length)}`;
    if (!galleryWrap) return;
    galleryWrap.querySelectorAll("button").forEach((button, buttonIndex) => {
      button.classList.toggle("is-active", buttonIndex === galleryIndex);
    });
    const active = galleryWrap.querySelector("button.is-active");
    if (active && active.scrollIntoView) active.scrollIntoView({ inline: "nearest", block: "nearest", behavior: "smooth" });
  }

  function renderGallery(media) {
    if (!galleryWrap) return;
    const source = media && media.gallery ? media : currentMedia();
    const images = (source.gallery && source.gallery.length ? source.gallery : [source.image]).filter(Boolean);
    if (productCount) {
      productCount.textContent = images.length ? `${padCount(1)} / ${padCount(images.length)}` : "";
    }
    galleryImages = images;
    galleryIndex = 0;
    galleryWrap.innerHTML = images.map((src, index) => (
      `<button type="button" class="${index === 0 ? "is-active" : ""}" data-gallery-src="${src}" aria-label="View image ${index + 1}"><img src="${src}" alt=""></button>`
    )).join("");
    galleryWrap.querySelectorAll("button").forEach((button, index) => {
      button.addEventListener("click", () => showGalleryAt(index));
    });
  }

  function bindGalleryControls() {
    const wrap = qs(".product__image-wrap");
    const prev = qs("[data-gallery-prev]");
    const next = qs("[data-gallery-next]");
    if (prev) prev.addEventListener("click", () => showGalleryAt(galleryIndex - 1));
    if (next) next.addEventListener("click", () => showGalleryAt(galleryIndex + 1));
    if (!wrap || swipeBound) return;
    swipeBound = true;
    let startX = 0;
    let startY = 0;
    let tracking = false;
    wrap.addEventListener("pointerdown", (event) => {
      if (event.target.closest("button")) return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
    });
    wrap.addEventListener("pointerup", (event) => {
      if (!tracking) return;
      tracking = false;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      showGalleryAt(galleryIndex + (dx < 0 ? 1 : -1));
    });
    wrap.addEventListener("pointercancel", () => { tracking = false; });
  }

  function setProduct(key, scrollToOrder = false) {
    if (!products[key]) return;
    if (key !== activeProduct) {
      activeProduct = key;
      selectedSize = null;
      if (productRoot) productRoot.classList.add("is-switching");
      qsa("[data-product-tab]").forEach((tab) => {
        const isActive = tab.dataset.productTab === key;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-pressed", String(isActive));
      });
      syncRoastLabel(key);
      window.setTimeout(() => {
        renderProduct(key);
        syncBuyState();
        if (productRoot) requestAnimationFrame(() => productRoot.classList.remove("is-switching"));
      }, reduceMotion ? 0 : 220);
    }
    if (scrollToOrder && orderSection) {
      orderSection.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    }
  }

  const productTabs = qsa("[data-product-tab]");
  productTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => setProduct(tab.dataset.productTab));
    tab.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      const direction = event.key === "ArrowRight" ? 1 : -1;
      const nextTab = productTabs[(index + direction + productTabs.length) % productTabs.length];
      nextTab.focus();
      setProduct(nextTab.dataset.productTab);
    });
  });
  qsa("[data-quick-product]").forEach((button) => {
    button.addEventListener("click", () => setProduct(button.dataset.quickProduct, true));
  });

  qsa("[data-gender]").forEach((button) => {
    button.addEventListener("click", () => {
      activeGender = button.dataset.gender;
      selectedSize = null;
      qsa("[data-gender]").forEach((item) => {
        const isActive = item.dataset.gender === activeGender;
        item.classList.toggle("is-selected", isActive);
        item.setAttribute("aria-pressed", String(isActive));
      });
      renderSizes();
      const media = currentMedia();
      renderGallery(media);
      setHeroImage(media.image);
      syncBuyState();
    });
  });

  function showToast(message) {
    const node = toast || qs(".toast") || document.querySelector(".toast");
    if (!node) return;
    window.clearTimeout(toastTimer);
    node.textContent = message;
    node.classList.add("is-visible");
    toastTimer = window.setTimeout(() => node.classList.remove("is-visible"), 2200);
  }

  function cartRoutes() {
    return {
      add: "/cart/add.js",
      cart: "/cart.js"
    };
  }

  function setBuyBusy(busy) {
    [buyButton, dockBuy].forEach((button) => {
      if (!button) return;
      if (busy) {
        button.setAttribute("aria-busy", "true");
        button.setAttribute("aria-disabled", "true");
        button.disabled = true;
      } else {
        button.removeAttribute("aria-busy");
        button.removeAttribute("aria-disabled");
        button.disabled = false;
      }
    });
  }

  async function refreshThemeCart(parsedState, variantId) {
    const drawer = document.querySelector("cart-drawer");
    const source = buyButton || dockBuy || document.body;
    let cartJson = parsedState;
    try {
      cartJson = await (await fetch(cartRoutes().cart, { headers: { Accept: "application/json" } })).json();
      if (parsedState && parsedState.sections) cartJson.sections = parsedState.sections;
    } catch (error) {
      cartJson = parsedState;
    }
    if (typeof theme !== "undefined" && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: "kaapi",
        productVariantId: String(variantId),
        cart: cartJson
      });
    }
    document.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true, detail: { product: parsedState } }));
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } }));
    if (drawer && typeof drawer.show === "function") drawer.show(source);
  }

  async function shopSelectedPair() {
    if (addingToCart) return;
    if (!selectedSize) {
      const picker = qs(".size-picker");
      if (picker) picker.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
      showToast("PICK YOUR UK SIZE FIRST");
      return;
    }
    const variant = selectedVariant();
    const item = products[activeProduct];
    if (!variant || !variant.id) {
      showToast("THIS SIZE IS UNAVAILABLE");
      return;
    }

    addingToCart = true;
    setBuyBusy(true);

    const variantId = Number(variant.id);
    try {
      const response = await fetch(cartRoutes().add, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });
      const parsedState = await response.json().catch(() => ({}));
      if (!response.ok || parsedState.status) {
        const message = parsedState.description || parsedState.message || "Could not add to cart";
        showToast(String(message).toUpperCase());
        document.dispatchEvent(new CustomEvent("ajaxProduct:error", { detail: { errorMessage: parsedState.description } }));
        return;
      }
      await refreshThemeCart(parsedState, variantId);
      showToast(`${item ? item.name : "KAAPI"} / UK ${selectedSize} ADDED`);
    } catch (error) {
      showToast("COULD NOT ADD TO CART");
    } finally {
      addingToCart = false;
      setBuyBusy(false);
    }
  }

  function copyOfferCode(code) {
    const value = String(code || "").trim();
    if (!value) return;
    const done = () => showToast(`${value} COPIED`);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(done).catch(() => {
        fallbackCopy(value);
        done();
      });
      return;
    }
    fallbackCopy(value);
    done();
  }

  function fallbackCopy(value) {
    const field = document.createElement("textarea");
    field.value = value;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.left = "-9999px";
    document.body.appendChild(field);
    field.select();
    try { document.execCommand("copy"); } catch (error) {}
    field.remove();
  }

  const offerCode = qs("[data-copy-code]");
  if (offerCode) {
    offerCode.addEventListener("click", () => copyOfferCode(offerCode.dataset.copyCode || offerCode.textContent));
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-buy], [data-dock-buy]");
    if (!trigger) return;
    event.preventDefault();
    shopSelectedPair();
  });

  const lastCallCta = qs(".last-call__cta");
  if (lastCallCta && orderSection) {
    lastCallCta.addEventListener("click", (event) => {
      event.preventDefault();
      orderSection.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", "#order");
      }
    });
  }

  const sizeGuide = qs("[data-size-guide]");
  function openKaapiSizeGuide() {
    const root = document.getElementById("KaapiSizeGuide");
    if (!root) return;
    const tab = root.querySelector(`[data-gl-sg-gender="${activeGender}"]`);
    if (tab) tab.click();
    if (typeof root._glOpen === "function") root._glOpen();
  }
  if (sizeGuide) sizeGuide.addEventListener("click", (event) => {
    event.preventDefault();
    openKaapiSizeGuide();
  });

  function updateScrollMotion() {
    ticking = false;
    const y = window.scrollY;
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if (pageProgress) pageProgress.style.transform = `scaleX(${y / maxScroll})`;
    if (!reduceMotion && beanStory && storyBean) {
      const storyRect = beanStory.getBoundingClientRect();
      const beanTravel = Math.max(0, beanStory.clientHeight - storyBean.offsetHeight);
      const beanProgress = clamp((window.innerHeight * 0.55 - storyRect.top) / Math.max(1, beanStory.offsetHeight - window.innerHeight * 0.35));
      storyBean.style.transform = `translate3d(0,${beanProgress * beanTravel}px,0) rotate(${beanProgress * 120}deg)`;
    }
    if (!reduceMotion && pourSection && pourMedia) {
      const pourRect = pourSection.getBoundingClientRect();
      if (pourRect.bottom > 0 && pourRect.top < window.innerHeight) {
        pourMedia.style.transform = `translateY(${(pourRect.top * 0.4 * -1).toFixed(2)}px)`;
      }
    }
    if (dock && orderSection && lastCall) {
      const orderRect = orderSection.getBoundingClientRect();
      const lastRect = lastCall.getBoundingClientRect();
      const showDock = orderRect.top < window.innerHeight * 0.28 && lastRect.top > window.innerHeight * 0.72;
      dock.classList.toggle("is-visible", showDock);
      dock.setAttribute("aria-hidden", String(!showDock));
      dock.inert = !showDock;
    }
  }

  function requestScrollUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateScrollMotion);
  }

  window.addEventListener("scroll", requestScrollUpdate, { passive: true });
  window.addEventListener("resize", requestScrollUpdate);
  window.addEventListener("load", requestScrollUpdate);
  renderProduct(activeProduct);
  bindGalleryControls();
  renderSizes();
  syncBuyState();
  updateScrollMotion();
})();
